// FooterFaqSection
import { CreatorLevels } from 'types/addCredits';
import React, { useState } from 'react';
import styles from './FooterFAQSection.module.sass';
import {
  CREATOR_LEVELS,
  FREQUENTLY_ASKED_QUESTIONS,
} from 'constants/addCredits';
import Question from './Question';
import CreatorLevelExample from './CreatorLevelExample';
import cn from 'classnames';

export interface FooterFaqSectionProps {}

const FooterFaqSection: React.FC<FooterFaqSectionProps> = ({}) => {
  const [levelSelected, setLevelSelected] = useState<CreatorLevels>(1);

  const handleTabChange: React.MouseEventHandler<HTMLButtonElement> = ({
    currentTarget: { id },
  }) => {
    setLevelSelected(Number(id) as CreatorLevels);
  };

  return (
    <div className={styles.footerFaqSection}>
      <p className={styles.levelCost}>
        Each creator you hire with these credits will produce 2 videos or 5
        photos (depending on your project) with 100% licensing rights for you.
        Each creator costs between 20 and 60 credits to work with.
      </p>
      <div className={styles.creatorLevels}>
        <div className={styles.levelTabs}>
          <button
            className={cn(styles.levelTab, {
              [styles.selected]: levelSelected === 1,
            })}
            id="1"
            onClick={handleTabChange}
          >
            20 Credits
          </button>
          <button
            className={cn(styles.levelTab, {
              [styles.selected]: levelSelected === 2,
            })}
            id="2"
            onClick={handleTabChange}
          >
            40 Credits
          </button>
          <button
            className={cn(styles.levelTab, {
              [styles.selected]: levelSelected === 3,
            })}
            id="3"
            onClick={handleTabChange}
          >
            60 Credits
          </button>
        </div>
        {CREATOR_LEVELS.map((creatorLevel) => (
          <CreatorLevelExample
            key={creatorLevel.level}
            {...creatorLevel}
            isVisible={creatorLevel.level == levelSelected}
          />
        ))}
        <div className={styles.levelExplainer}>
          Your brand needs a balance of authentic user generated content (level
          1) and more professionally shot content (levels 2 & 3) to cover your
          needs online. Trend is here to deliver on any and all of it. You’ll
          see the cost to work with each creator in their profiles on the
          applications tab. If you have questions about specific applicants
          reach out to us in the chat bubble, we know our creators well and are
          happy to give recommendations.{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://meetings.hubspot.com/trend/consult"
          >
            You can always schedule time to talk here too.
          </a>
        </div>
      </div>
      <div className={styles.faqs}>
        <h2 className={styles.faqTitle}>FAQs</h2>
        {FREQUENTLY_ASKED_QUESTIONS.map((faq) => (
          <Question key={faq.question} {...faq} />
        ))}
      </div>
    </div>
  );
};

export default FooterFaqSection;
